import type { MouseEventHandler } from 'react';
import { useEffect } from 'react';
import { useSettings } from '@wu/widget-core';
import { useInView } from 'react-intersection-observer';
import type { Job } from '../../types';
import { useLayout } from './LayoutProvider';
import { variations } from './variations';

type LayoutProps = {
  jobs: Job[];
};

export function Layout({ jobs }: LayoutProps) {
  const { layout } = useSettings();
  const { autoplay } = useLayout();
  const [intersectionRef, visibility] = useInView();

  useEffect(() => {
    if (autoplay?.enabled) {
      visibility ? autoplay.start() : autoplay.stop();
    }
  }, [autoplay, visibility]);

  const handleMouseEnter: MouseEventHandler = () => {
    if (autoplay?.enabled) {
      autoplay.stop();
    }
  };
  const handleMouseLeave: MouseEventHandler = () => {
    if (autoplay?.enabled) {
      autoplay.start();
    }
  };

  const LayoutComponent = variations[layout];

  return (
    <LayoutComponent
      jobs={jobs}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={intersectionRef}
    />
  );
}
